import { useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useColumns = () => {
  const getColumns = useCallback(async () => {
    try {
      return await RequestService.getColumns()
    } catch (e) {
      console.log('useColumns', e)
    }
  }, [])

  const saveColumns = useCallback(
    async ({
      id,
      highFatigue,
      notification,
      counterMeasure,
      fatigueLevel8h,
      intakePending,
    }) => {
      try {
        return await RequestService.saveColumns({
          id,
          highFatigue,
          notification,
          counterMeasure,
          fatigueLevel8h,
          intakePending,
        })
      } catch (e) {
        console.log('useColumns', e)
      }
    },
    [],
  )

  return { getColumns, saveColumns }
}

export default useColumns
